import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/apiClient";
import { Reveal } from "@/components/Reveal";
import { MapPin } from "lucide-react";

export default function Directory() {
  const [members, setMembers] = useState([]);
  useEffect(() => { api.get("/members").then((r) => setMembers(r.data)).catch(() => {}); }, []);

  return (
    <div className="min-h-screen bg-bone pt-20 md:pt-14 pb-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal>
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-black">The Brotherhood</span>
          <h1 className="font-serif font-light text-5xl md:text-7xl tracking-tight mt-4">Member Directory</h1>
          <p className="font-sans text-charcoal/60 mt-4">{members.length} men walking together.</p>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-charcoal/10 border border-charcoal/10 mt-16">
          {members.map((m, i) => (
            <Reveal key={m.id} delay={(i % 3) * 0.06} className="bg-bone">
              <Link to={`/members/${m.id}`} className="block p-8 h-full hover:bg-sand transition-colors duration-400" data-testid={`member-${m.id}`}>
                <div className="flex items-center gap-4">
                  {m.avatar ? (
                    <img src={m.avatar} alt={m.name} className="w-16 h-16 object-cover" />
                  ) : (
                    <div className="w-16 h-16 bg-olive text-bone flex items-center justify-center font-serif text-2xl">{m.name?.[0]}</div>
                  )}
                  <div>
                    <h3 className="font-serif text-2xl tracking-tight leading-tight">{m.name}</h3>
                    {m.role === "admin" && <span className="font-mono text-[10px] uppercase tracking-widest text-gold">Ministry Leader</span>}
                  </div>
                </div>
                {m.focus && <p className="font-mono text-xs uppercase tracking-widest text-charcoal/50 mt-6">{m.focus}</p>}
                {m.bio && <p className="font-sans text-sm text-charcoal/70 mt-3 leading-relaxed line-clamp-3">{m.bio}</p>}
                {m.location && <p className="font-sans text-xs text-charcoal/50 mt-4 flex items-center gap-2"><MapPin size={12} /> {m.location}</p>}
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
